module.exports = __webpack_public_path__ + "img/1.d647e648.png";